module.exports = __webpack_public_path__ + "img/vegetable-rutabaga-190x100.4b964040.jpg";